import { lazy, Suspense } from 'react';
import LoadingCom from '../../../components/LoadingCom';
import PageErrorBoundary from '../../../components/PageErrorBoundary';

const Step2 = lazy(() => import('./Index'));

export default function SuspendedStep2SetupPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Step2 {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
